import logger from '../logger';

export const reachGoal = (goal, product) => {
  try {
    if (!window.dataLayer) {
      window.dataLayer = [];
    }

    const event = { event: goal };

    if (product) {
      event.product = product;
    }

    window.dataLayer.push(event);
  } catch (error) {
    logger.captureException(error);
  }
};

export const sendDataLakeEvent = (goal, product) => {
  reachGoal(goal, product);
};

export const sendDataLakeEventRating = (goal) => {
  sendDataLakeEvent(goal, 'Rating');
};

export const GOALS = {
  rating: {
    pageOpen: 'PageOpen',
  },
};
